// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BUQrS","footer":"styles_footer__OF_kJ","footerItem":"styles_footerItem__JxyTB"};